var map = {
	"./de.png": 1055,
	"./en.png": 1056,
	"./es.png": 1057,
	"./fr.png": 1058,
	"./ja.png": 1059,
	"./mk.png": 1060,
	"./pt.png": 1061,
	"./tr.png": 1062,
	"./zh.png": 1063
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 1054
// module chunks = 0